import {observer} from "mobx-react-lite";
import { useInjection } from "../../../react-binding";
import { SimpleLeadScreenState } from "./SimpleLeadScreen.state";
import { defaultDisclaimerUrl, defaultLeadMail } from "../../../constants/constants";
import { TextInput } from "../../Alpha/partials/TextInput";
import { action } from "mobx";
import { NavigationService } from "../../../services/NavigationService/NavigationService";
import { determinePhpEndpointDomain } from "../../../helpers/helpers";
import { BankService } from "../../../services/Bank/BankService";

//@observer
export const SimpleLeadScreen = observer(() => {

    const navigationService = useInjection(NavigationService);
    const simpleLeadScreenState = useInjection(SimpleLeadScreenState);
    const bankService = useInjection(BankService);

    const handleSubmit = action(() => {
        try {
            sendMail()
        } catch(e) {
            console.error("SOMETHING WENT WRONG:", e);
        }
    })

    async function sendMail() {
        return new Promise(async (resolve) => {
            const textAreaElement = document.getElementById('lead-message') as HTMLTextAreaElement;
            const request = new XMLHttpRequest();
            request.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    return resolve("SUCCESS");
                }
            }


            const sendTo = navigationService.domainSettings?.leadMail ?? defaultLeadMail;
            
            const endpoint = `${bankService.dataService.phpScriptEndpoint}mail_${bankService.dataService.sanitizedDomain}.php`
//            const urlEndpoint = "https://phpscripts.hypokalk.cz/mail_hypokalk_cz.php"
            const queryParams = `?name=${simpleLeadScreenState.state.name}&telefon=${simpleLeadScreenState.state.phoneNr}&mail=${simpleLeadScreenState.state.email}&zprava=${textAreaElement?.value}&prijemce=${sendTo}`
            const finalUrl = endpoint+encodeURI(queryParams);
            try {
                request.open("POST", finalUrl, true)
                await request.send();
                simpleLeadScreenState.dataSent.value = true;                
            } catch(e) {
                console.error(e);
                throw "Could not send data";
            }

        })
    }


    const checkBoxChange = action((e: React.ChangeEvent<HTMLInputElement>) => {
        simpleLeadScreenState.consentGranted.value = e.target.checked;
        validateFields();
    })

    function isPhoneNrValid() {
        return simpleLeadScreenState.state.phoneNr.replaceAll(' ','')
        .match(
        /^([\+][0-9]{1,3})?[0-9]{9}$/im
        )
    }

    function isEmailValid() {
        return simpleLeadScreenState.state.email
        .toLowerCase()
        .match(
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        )
    }

    function isNameValid() {
        // Anything is allowed in the name field
        return !!simpleLeadScreenState.state.name;
    }

    function validateFields() {
//        const state = simpleLeadScreenState.state;
        const phoneNumberValid = isPhoneNrValid();
        const emailValid = isEmailValid();
        const nameValid = isNameValid();

        if (phoneNumberValid && emailValid && nameValid && simpleLeadScreenState.consentGranted.value) {
            simpleLeadScreenState.valid.value = true;
        } else {
            simpleLeadScreenState.valid.value = false;
        }
    }

    return (<span className="hypolead">
{/*
        <h1>Zanechte kontakt</h1>
*/}

        {!simpleLeadScreenState.dataSent.value ? <>
        {/*
            <p>
                Pokud máte zájem o pomoc se sjednáním úvěru na bydlení či o nezávaznou nabídku v této oblasti, vyplňte níže uvedený formulář. 
            </p>
        */}
            <div className="inputs-section">

                <div className={`field-wrapper ${isNameValid() ? '' : 'invalid-input'}`}>
                        <span className="field-name">
                            Jméno a příjmení:
                        </span>
                            <TextInput
                                observable = {simpleLeadScreenState.state}
                                field = "name"
                                onChangeCallback = {validateFields}
                                placeholder = "Jméno a příjmení"
                            />
                </div>
                    
                <div className={`field-wrapper ${isPhoneNrValid() ? '' : 'invalid-input'}`}>
                    <span className="field-name">
                        Telefon:
                    </span>
                        <TextInput
                            observable = {simpleLeadScreenState.state}
                            field = "phoneNr"
                            onChangeCallback = {validateFields}
                            placeholder = "Vaše telefonní číslo"
                        />
                </div>

                <div className={`field-wrapper ${isEmailValid() ? '' : 'invalid-input'}`}>
                    <span className="field-name">
                        Email:
                    </span>
                        <TextInput
                            observable = {simpleLeadScreenState.state}
                            field = "email"
                            onChangeCallback = {validateFields}
                            placeholder = "Vaše emailová adresa"
                        />
                </div>
            </div>

            <div className="text-area-wrapper">
                <div className="field-name">
                    Vzkaz (nepovinné, max. 350 znaků)
                </div>
                <textarea
                    id="lead-message"
                    rows={5}
                    cols={50}
                    maxLength={350}
                />
            </div>

            <div className={`consent-check ${simpleLeadScreenState.consentGranted.value ? '' : 'invalid-input'}`}>
                <input type="checkbox" onChange={(e) =>
                    checkBoxChange(e)
                }/>

                {   navigationService.domainSettings?.disclaimerUrl ? <>
                        Souhlasím s <a className="link-like" target="_blank" href={navigationService.domainSettings?.disclaimerUrl}>podmínkami</a> zpracování osobních údajů
                    </>:<>
                        Odesláním tohoto formuláře souhlasíte s tím, že budete v blízké době kontaktování finančním poradcem. Vaše osobní údaje za tímto účelem v rozsahu e-mail, telefonní číslo, jméno a příjmení zpracovává nejdéle po dobu 6
                        měsíců {navigationService.domainSettings?.disclaimerInfo.company}, IČ: {navigationService.domainSettings?.disclaimerInfo.ic}, se sídlem {navigationService.domainSettings?.disclaimerInfo.address}
                    </>
                }
                

            </div>


            <button className="submit-button" onClick={() => handleSubmit()} disabled={!simpleLeadScreenState.valid.value}>
                {simpleLeadScreenState.valid.value ? 'Odeslat kontakt' : 'Vyplňte všechna povinná pole'}
            </button>
        </> : <>
            <p>
                Váš kontakt byl zaznamenán.
            </p>
        </>}
    </span>)
})